import styled from 'styled-components'
import { IconSendFill as BuiIconSendFill, colors } from '@blocket/blocket-ui'
import { mediaQueries } from 'plugins/device'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding: 10px 14px;
  padding-left: ${({ mobileView }) => (mobileView ? '6' : '14')}px;
`

export const TextAreaWrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 5px;
  background-color: ${colors.grey200};
  border-radius: 16px;

  @media ${mediaQueries.small} {
    padding: 16px;
    border-radius: 40px;
  }
`

export const TextArea = styled.textarea`
  width: 100%;
  height: 100%;
  padding-left: 6px;
  padding-right: 6px;
  flex-grow: 1;
  overflow-x: hidden;
  box-sizing: border-box;
  color: ${colors.grey800};
  font-family: BlocketSans-Regular;
  font-size: 17px;
  font-weight: normal;
  line-height: 26px;
  background-color: transparent;
  outline: none;
  resize: none;

  &::placeholder {
    color: ${colors.grey500};
  }

  @media ${mediaQueries.small} {
    padding-left: 22px;
    padding-right: 22px;
  }
`

export const InnerIconWrapper = styled.div`
  display: flex;
  align-self: flex-end;
  margin-bottom: 6px;
  @media ${mediaQueries.medium} {
    margin-bottom: 16px;
  }
`

export const IconContainer = styled.div`
  align-self: flex-end;
  margin-bottom: 6px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  @media ${mediaQueries.medium} {
    margin-bottom: 16px;
  }
`

export const UploadButton = styled.button`
  display: flex;
  align-items: center;
  margin-right: 12px;
  cursor: pointer;
`

export const IconSendButton = styled.button`
  display: flex;
  cursor: pointer;
  padding-left: 8px;
`

export const Input = styled.input`
  display: none;
`

export const IconSendFill = styled(BuiIconSendFill)`
  color: ${colors.blue600};
`
